import { GetQuickJournalNow } from "../Clock/QuickJournalClock";
import { GetDayHourKey, GetLocalDayKeyFromDate } from "../QuickJournalKeys";
import { IQuickJournalStats } from "../QuickJournalTypes";
import { BuildQuickJournalDayCountsFromHourlyCounts } from "./QuickJournalStatsDemoHelpers";

export function BuildQuickJournalDemoStats(): IQuickJournalStats {
    const weeklyHourlyCounts = BuildQuickJournalDemoWeeklyHourlyCounts();

    return {
        dailyCounts: BuildQuickJournalDayCountsFromHourlyCounts(
            weeklyHourlyCounts
        ),
        weeklyHourlyCounts,
    };
}

function BuildQuickJournalDemoWeeklyHourlyCounts(): Record<string, number> {
    const counts: Record<string, number> = {};
    const pattern = [
        [0, 0, 0, 1, 1, 2, 2, 1, 0, 0, 1, 2, 3, 3, 2, 1, 1, 2, 3, 4, 3, 2, 1, 0],
        [0, 0, 1, 1, 2, 2, 2, 1, 0, 1, 1, 2, 3, 4, 3, 2, 2, 3, 4, 5, 4, 3, 1, 0],
        [0, 1, 1, 2, 2, 3, 3, 2, 1, 1, 2, 3, 4, 5, 4, 3, 3, 4, 5, 6, 5, 4, 2, 1],
        [0, 0, 1, 1, 2, 2, 2, 1, 0, 1, 1, 2, 3, 4, 3, 2, 2, 3, 4, 5, 4, 3, 1, 0],
        [0, 0, 0, 1, 1, 2, 2, 1, 0, 0, 1, 2, 3, 3, 2, 1, 1, 2, 3, 4, 3, 2, 1, 0],
        [0, 0, 1, 1, 2, 3, 3, 2, 1, 1, 2, 3, 4, 5, 4, 3, 2, 3, 4, 5, 4, 3, 2, 1],
        [0, 0, 0, 1, 1, 2, 2, 1, 0, 0, 1, 2, 3, 3, 2, 1, 1, 2, 3, 4, 3, 2, 1, 0],
    ];

    const today = GetQuickJournalNow();
    today.setHours(12, 0, 0, 0);

    pattern.forEach((row, rowIndex) => {
        const day = new Date(today);
        day.setDate(today.getDate() - rowIndex);
        const dayKey = GetLocalDayKeyFromDate(day);

        row.forEach((count, hour) => {
            counts[GetDayHourKey(dayKey, hour)] = count;
        });
    });

    return counts;
}
